<div class="add-edit-topic">
  <form [formGroup]="topicForm" (submit)="onSubmit()">
    <app-input-wrapper>
      <label>Title <span>*</span></label>
      <input
        type="text"
        placeholder="Title"
        formControlName="name"
        inNoWhitespace
      />
      <span
        *ngIf="topicForm.get('name')?.errors?.['required']&&(topicForm.get('name')?.dirty||topicForm.get('name')?.touched)"
      >
        Title is required
      </span>
    </app-input-wrapper>
    <div class="add-edit-topic__upload">
      <label>Add Image <span>*</span></label>
      <app-upload-image
        (uploadEnd)="onUploadEnd($event)"
        (uploadStart)="onUploadStart()"
        [previewUrl]="imageUrl"
        (removeImage)="removeImage()"
      ></app-upload-image>
      <div
        class="add-edit-topic__error"
        *ngIf="topicForm.get('img')?.errors?.['required']&&(topicForm.get('img')?.dirty||topicForm.get('img')?.touched)"
      >
        Image is required
      </div>
    </div>
    <div class="flex justify-end">
      <app-button
        [type]="'button'"
        label="Cancel"
        customClass="outline"
        (action)="handleClose()"
      ></app-button>
      <app-button
        [type]="'submit'"
        label="Submit"
        [isDisabled]="imageUploading || isLoading"
        [isLoading]="isLoading"
      >
        <app-button-loader *ngIf="isLoading" postfixContent></app-button-loader>
      </app-button>
    </div>
  </form>
</div>
